module.exports = __webpack_public_path__ + "img/price-lang.66e2ff24.png";